/* NDC · Fase 4 · Artículo: barra de progreso, TOC desde los H2, CTA sticky contextual (design/02 §4, 01 §2.20).
   10 sep 2026: ofertas del blog (ndc-offer) — medición de clics y exclusión de sus títulos del índice.
   Vanilla, defer. Convive con ndc-redesign.js (que ya gestiona el "+" de las cards y el toast). */
(function () {
  'use strict';
  var article = document.querySelector('[data-ndc-article]');
  if (!article) return;
  var track = function (payload) { try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {} };
  var mqDesktop = window.matchMedia('(min-width: 1100px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Progreso de lectura ---------- */
  var bar = document.querySelector('[data-ndc-progress] .ndc-article-progress__bar');
  var progress = 0;
  function readProgress() {
    var doc = document.documentElement;
    var max = (doc.scrollHeight - window.innerHeight) || 1;
    return Math.min(1, Math.max(0, (window.scrollY || doc.scrollTop) / max));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      progress = readProgress();
      if (bar) bar.style.width = (progress * 100).toFixed(2) + '%';
      updateRail();
      updateCta();
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- TOC ---------- */
  var toc = document.querySelector('[data-ndc-toc]');
  var wrap = document.querySelector('.ndc-article-wrap');
  var heads = Array.prototype.slice.call(article.querySelectorAll('h2')).filter(function (h) {
    return h.textContent.trim().length > 0 && !h.closest('.ndc-article-products') && !h.closest('.ndc-cta-card') && !h.closest('.ndc-offer');
  });
  function slugify(s) {
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'seccion';
  }
  var links = [];
  if (toc && heads.length >= 2) {
    var list = toc.querySelector('[data-ndc-toc-list]');
    var used = {};
    heads.forEach(function (h, i) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        if (used[id]) id += '-' + (i + 1);
        h.id = id;
      }
      used[id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
    toc.hidden = false;
    if (mqDesktop.matches) toc.open = true;
    toc.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      /* offset del header sticky de Flex (mobile-header.sticky--enabled / .site-header) */
      var hdr = document.querySelector('#mobile-header.sticky--enabled, .mobile-header.sticky--enabled, .site-header.sticky--enabled, .header-section.sticky--enabled');
      var hdrH = 0;
      if (hdr) hdrH = hdr.getBoundingClientRect().height; /* sticky--enabled: se fija al hacer scroll aunque ahora sea static */
      var goTo = function (smooth) {
        var top = target.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop) - hdrH - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
      };
      goTo(!reduced);
      /* las imágenes del contenido no traen alto: al cargarse desplazan el objetivo; se corrige dos veces */
      setTimeout(function () { goTo(false); }, reduced ? 60 : 900);
      setTimeout(function () { goTo(false); }, reduced ? 400 : 1800);
      history.replaceState(null, '', a.getAttribute('href'));
      if (!mqDesktop.matches) toc.open = false;
      track({ event: 'toc_click', section: target.id });
    });
    if ('IntersectionObserver' in window) {
      var active = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var idx = heads.indexOf(en.target);
            if (idx < 0) return;
            if (active) active.classList.remove('is-active');
            active = links[idx];
            active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-10% 0px -70% 0px', threshold: 0 });
      heads.forEach(function (h) { io.observe(h); });
    }
  } else if (toc) {
    toc.hidden = true;
    /* sin índice: la columna izquierda solo se mantiene si hay tarjeta de oferta (rail) */
    if (wrap && !document.querySelector('.ndc-offer--rail')) wrap.classList.add('no-toc');
  }

  /* ---------- Rail editorial: índice primero, descubrimiento desde el 3.er H2 ---------- */
  var railIndex = document.querySelector('[data-ndc-rail-index]');
  var railDiscovery = document.querySelector('[data-ndc-rail-discovery]');
  var railSwitchHead = heads.length >= 3 ? heads[2] : null;
  function setRailDiscovery(show) {
    if (!railIndex || !railDiscovery) return;
    railIndex.hidden = show;
    railDiscovery.hidden = !show;
    railIndex.classList.toggle('is-active', !show);
    railDiscovery.classList.toggle('is-active', show);
  }
  function updateRail() {
    if (!railIndex || !railDiscovery) return;
    if (!mqDesktop.matches) { setRailDiscovery(false); return; }
    var headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ndc-header-h')) || 0;
    var showDiscovery;
    if (railSwitchHead) {
      showDiscovery = railSwitchHead.getBoundingClientRect().top <= headerOffset + 96;
    } else {
      var rect = article.getBoundingClientRect();
      var travelled = Math.max(0, headerOffset + 96 - rect.top);
      showDiscovery = travelled >= rect.height * 0.52;
    }
    setRailDiscovery(showDiscovery);
  }

  /* ---------- CTA sticky contextual ---------- */
  var cta = document.querySelector('[data-ndc-article-cta]');
  var ctaKey = 'ndc_article_cta_closed';
  var ctaClosed = false;
  try { ctaClosed = sessionStorage.getItem(ctaKey) === '1'; } catch (e) {}
  var threshold = cta ? (parseInt(cta.getAttribute('data-threshold'), 10) || 30) / 100 : 0.3;
  var bandVisible = false;
  var band = document.querySelector('.ndc-cta-band, [data-cta-slot="band"]');
  if (cta && band && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bandVisible = en.isIntersecting; });
      updateCta();
    }, { threshold: 0.05 }).observe(band);
  }
  var ctaShown = false;
  function showCta(show) {
    if (!cta) return;
    if (show && !ctaShown) {
      cta.hidden = false;
      requestAnimationFrame(function () { cta.classList.add('is-visible'); });
      document.body.classList.add('ndc-has-article-cta');
      document.body.classList.add('ndc-sticky-visible');
      ctaShown = true;
      track({ event: 'blog_cta_view', cta_type: cta.getAttribute('data-cta-type') });
    } else if (!show && ctaShown) {
      cta.classList.remove('is-visible');
      document.body.classList.remove('ndc-has-article-cta');
      document.body.classList.remove('ndc-sticky-visible');
      ctaShown = false;
    }
  }
  function updateCta() {
    if (!cta || ctaClosed || mqDesktop.matches) { showCta(false); return; }
    showCta(progress >= threshold && progress < 0.98 && !bandVisible);
  }
  if (cta) {
    var closeBtn = cta.querySelector('[data-ndc-cta-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      ctaClosed = true;
      try { sessionStorage.setItem(ctaKey, '1'); } catch (e) {}
      showCta(false);
      setTimeout(function () { cta.hidden = true; }, reduced ? 0 : 350);
      track({ event: 'blog_cta_close', cta_type: cta.getAttribute('data-cta-type') });
    });
    cta.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-cta-type]');
      if (!a) return;
      track({ event: 'blog_cta_click', cta_type: a.getAttribute('data-cta-type'), cta_slot: 'sticky', cta_href: a.getAttribute('href') });
    });
  }

  var onMq = function () {
    updateCta();
    updateRail();
    if (toc && heads.length >= 2) toc.open = mqDesktop.matches;
  };
  mqDesktop.addEventListener ? mqDesktop.addEventListener('change', onMq) : mqDesktop.addListener(onMq);

  /* ---------- Clics en el bloque de productos / relacionados (GA4) ---------- */
  document.addEventListener('click', function (e) {
    /* ofertas del blog (tarjetas inline/mid, banda final, rail): blog_cta_click con el handle de la oferta */
    var offer = e.target.closest('.ndc-offer a[data-cta-type]');
    if (offer) {
      var box = offer.closest('.ndc-offer');
      track({ event: 'blog_cta_click', cta_type: offer.getAttribute('data-cta-type'), cta_slot: box ? box.getAttribute('data-cta-slot') : 'inline', cta_href: offer.getAttribute('href') });
      return;
    }
    var card = e.target.closest('.ndc-article-products .ndc-card a');
    if (card) { track({ event: 'article_product_click', product_id: card.closest('[data-product-id]').getAttribute('data-product-id') }); return; }
    var rel = e.target.closest('.ndc-related__card');
    if (rel) track({ event: 'related_article_click', href: rel.getAttribute('href') });
  });

  onScroll();
})();
